module.exports = __webpack_public_path__ + "assets/img/NVIDIA-67ec1587.png";